import { useEffect, useState } from 'react';
import { getUserInfo, runRequestWithToken, validateToken } from '../utils/api';
import { IUserInfo } from '../utils/types';
import { clearToken } from '../utils/token';

export const useUserData = () => {
  const [status, setStatus] = useState<'loading' | 'error' | 'ok'>('loading');
  const [userInfo, setUserInfo] = useState<IUserInfo>({});

  const makeRequest = async () => {
    try {
      await runRequestWithToken(validateToken);
      const res = await runRequestWithToken(getUserInfo);
      setStatus('ok');
      setUserInfo(res as IUserInfo);
    } catch {
      clearToken();
      setStatus('error');
    }
  }

  useEffect(() => {
    makeRequest();
  }, []);

  return {
    status,
    userInfo,
    refetchStatus: makeRequest
  }
}
